// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"82164af0","148":"6a9e4ac9"}[chunkId] + ".chunk.js";
};